import axios from 'axios';
import Vue from 'vue';
const PublicAffairsApp = () => import(/* webpackChunkName: "PublicAffairsIssueApp" */ "./PublicAffairsApp.vue");
const PublicAffairsAppTabbed = () => import(/* webpackChunkName: "PublicAffairsAppTabbed" */ "./PublicAffairsAppTabbed.vue");

window.animateMenu = function(x) {
    x.classList.toggle('change');
    $('.beta-wrapper').toggle();
}

function init_app() {

    if (window.Vue) {

        Vue.prototype.$http = axios;

        Vue.mixin({
            methods: {
                browser_has_storage: function () {
                    return (window.localStorage) ? true : false;
                },
            },
        });

        if(document.getElementById('public_affairs_app')){
            window.pa_app = new Vue({
                name: 'pa-issue-page',
                el: '#public_affairs_app',
                render: h => h(PublicAffairsApp),
            });
        }

        if(document.getElementById('public_affairs_app_tabbed')){
            window.pa_app = new Vue({
                name: 'pa-issue-page',
                el: '#public_affairs_app_tabbed',
                render: h => h(PublicAffairsAppTabbed),
            });
        }

    }

}

init_app();